export default __webpack_public_path__ + "static/leaflove-b61697301a07ffc81030cab85aff262a.jpg";